export * from './sort-by'

export const isObject = (val) => {
  if (val === null) { return false }
  return ((typeof val === 'function') || (typeof val === 'object'))
}
export const isEmpty = (val): boolean => {
  return (isObject(val) && Object.keys(val).length === 0) || val === undefined || val == null || val === '' || val.length <= 0
}
